import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@shared/inquiry";

/** The 5 default FAQ items, shared by the support page and the inquiry form. */
export function FaqList() {
  return (
    <Accordion type="single" collapsible className="w-full">
      {FAQ_ITEMS.map((f, i) => (
        <AccordionItem key={f.q} value={`faq-${i}`}>
          <AccordionTrigger className="text-left text-sm">{f.q}</AccordionTrigger>
          <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
